import GreenHeader from "../elements/GreenHeader";
import Header1 from "../elements/Header1";
import styled from "styled-components";
import industrialImage from '../media/images/industrial_roof.webp';
import wholeHouseImage from '../media/images/whole_flat_roof_house.jpeg';
import garageImage from '../media/images/usages/garage.webp';
import patioImage from '../media/images/usages/patio.webp';
import extensionImage from '../media/images/flat_roof_house_good.png';
import solarRoofImage from '../media/images/solar_roof.jpg';

const Wrapper = styled.div`
    display: block;
    width: 100%;
    //border: 1px solid #c58e50; 
    background-color: #f9f9f9;
    padding-top: 10px;
    padding-bottom: 200px;
`;

const UsagesWrapper = styled.div`
    display: inline-block;
    //border: 1px solid #c58e50;    
    width: 70%;
    margin-left: 15%;
`;

const UsagesBox = styled.div`
    display: block;
    width: 30%;
    //height: 350px;
    //border-radius: 25px;
    //border: 1px solid #35644c; 
    float: left;
    margin-top: 3%;
    margin-right: 2.5%;
    overflow: hidden;
    z-index: 10;
    //background-color: #35644c;
    background-repeat: no-repeat;
    background-size: cover;
`;

const IndustrialBox = styled(UsagesBox)`
    background-image: url(${industrialImage});
`;

const HouseBox = styled(UsagesBox)`
    background-image: url(${wholeHouseImage});
`;

const GarageBox = styled(UsagesBox)`
    background-image: url(${garageImage});
`;

const PatioBox = styled(UsagesBox)`
    background-image: url(${patioImage});
`;

const ExtensionBox = styled(UsagesBox)`
    background-image: url(${extensionImage});
`;

const SolarBox = styled(UsagesBox)`
    background-image: url(${solarRoofImage});
`;

const Mask = styled.div`
    //background-color: rgba(64,99,78,0.8);
    background-image: linear-gradient(to top, rgba(64, 99, 77, .8), rgba(64, 99, 77, 0.2), rgba(0, 0, 0, 0.1));
    width: 100%;
    padding-top: 60%;
    padding-bottom: 10%;
    padding-left: 5%;
    z-index: 10000;
    color: #ffffea;
`;

const MaskHeader = styled.div`
    font-size: 18px;
    font-weight: 700;
    @media (max-width: 1000px) {
        font-size: 14px;
    }
    @media (max-width: 800px) {
        font-size: 12px;
    }
    @media (max-width: 500px) {
        font-size: 10px;
        height: 20px;
    }
    
`;

const MaskParagraph = styled.div`
    font-size: 15px;
    display: block;
    width: 90%;
    height: 40px;
    overflow: hidden;
    @media (max-width: 1000px) {
        font-size: 12px;
    }
    @media (max-width: 800px) {
        font-size: 12px;
    }
    @media (max-width: 500px) {
        display: none;
    }
`;


function Usage() {
    return (
        <Wrapper>
            <GreenHeader title={"ПРИЛОЖЕННИЕ"}/>
            <Header1 title={"Разнообразие от приложения"}/>
            <UsagesWrapper>
                <IndustrialBox>
                    <Mask>
                        <MaskHeader>
                            Индустриални
                        </MaskHeader>
                        <MaskParagraph>
                            Подходяща за големи плоски покриви
                        </MaskParagraph>
                    </Mask>
                </IndustrialBox>
                <HouseBox>
                    <Mask>
                        <MaskHeader>
                            Къщи
                        </MaskHeader>
                        <MaskParagraph>
                            Модерни къщи с плосък покрив
                        </MaskParagraph>
                    </Mask>
                </HouseBox>
                <ExtensionBox>
                    <Mask>
                        <MaskHeader>
                            Пристройки
                        </MaskHeader>
                        <MaskParagraph>
                            Пристройки допълнителни постройки
                        </MaskParagraph>
                    </Mask>
                </ExtensionBox>
                <GarageBox>
                    <Mask>
                        <MaskHeader>
                            Гаражи
                        </MaskHeader>
                        <MaskParagraph>
                            Покриване на външни гаражи и постройки
                        </MaskParagraph>
                    </Mask>
                </GarageBox>
                <PatioBox>
                    <Mask>
                        <MaskHeader>
                            Навеси
                        </MaskHeader>
                        <MaskParagraph>
                            Хидроизолиране на навеси и веранди
                        </MaskParagraph>
                    </Mask>
                </PatioBox>
                <SolarBox>
                    <Mask>
                        <MaskHeader>
                            Соларни покриви
                        </MaskHeader>
                        <MaskParagraph>
                            Изолация на соларни покриви
                        </MaskParagraph>
                    </Mask>
                </SolarBox>
            </UsagesWrapper>
        </Wrapper>
    );
}

export default Usage;
